export default function TagNav() {
	const tagNav = document.querySelector('.tag-nav');
	const tagNavLinks = document.querySelectorAll('.tag-nav a');

	// Brief V (2026-08-28), task 4c — expose the (now full-bleed, task 4a)
	// bar's real height as a CSS custom property so `.product-archive__tag-
	// title`'s `scroll-margin-top` (_tag-nav.scss) always clears it,
	// including at breakpoints where the pills themselves are shorter
	// (task 4d shrank them on mobile) — measured at runtime instead of
	// hardcoding two breakpoint-specific numbers that would drift out of
	// sync with any future CSS tweak to the bar's padding/pill size.
	const updateTagNavHeight = () => {
		if (!tagNav) return;
		document.documentElement.style.setProperty('--tag-nav-height', `${tagNav.offsetHeight + 16}px`);
	};
	if (tagNav) {
		updateTagNavHeight();
		window.addEventListener('resize', updateTagNavHeight);
	}

	// Get #kapa-za-dimnjak from url and if it exists, add active class tag nav that has is as #id
	const url = window.location.href;
	const urlParts = url.split('#');
	const urlHash = urlParts[1];
	if(urlHash) {
		const tagNavLink = document.querySelector(`.tag-nav a[href="#${urlHash}"]`);
		if(tagNavLink) {
			tagNavLink.classList.add('active');
		}
	}

	if(!tagNavLinks) return;

	// Brief V (2026-08-28), task 4b — single source of truth for "which
	// pill is active", used by both the click handler (unchanged
	// behaviour, kept for instant feedback) and the new scroll-spy below,
	// so the two never disagree about what "active" means.
	const setActiveLink = (link) => {
		const activeLink = document.querySelector('.tag-nav a.active');
		if (activeLink && activeLink !== link) {
			activeLink.classList.remove('active');
		}
		if (link) {
			link.classList.add('active');
		}
	};

	// Task 4b — while a click's native `href="#slug"` jump is still under
	// way, don't let the scroll-spy observer fight the just-clicked pill
	// (the browser's anchor jump can briefly intersect other sections on
	// the way there). Cleared shortly after the click; the observer takes
	// back over for any further, ordinary scrolling — this is only a
	// short head start, not a second/competing source of truth.
	let suppressSpyUntil = 0;

	tagNavLinks.forEach(link => {
		link.addEventListener('click', () => {
			// Click keeps scrolling to the section exactly as before (native
			// anchor navigation via `href="#id"` — not touched here). Same
			// toggle nuance as the pre-existing handler: clicking the
			// already-active pill clears it instead of re-marking it. Note
			// that if the user hasn't actually scrolled away from that
			// section, the scroll-spy below will naturally re-activate it
			// once `suppressSpyUntil` elapses — expected, since scroll
			// position is now the source of truth for "which filter is
			// current" (see RESULT).
			if (link.classList.contains('active')) {
				link.classList.remove('active');
			} else {
				setActiveLink(link);
			}
			suppressSpyUntil = Date.now() + 700;
		});
	});

	// Task 4b — scroll-spy: as the user scrolls (not just on click), the
	// pill matching whichever tagged section is currently in view
	// activates itself. Targets are the exact same `#{slug}` headings the
	// pills already link to (taxonomy-product-category.php outputs
	// `<h3 id="...">` per tag) — no new markup needed, and the anchor-jump
	// / URL-hash logic above is untouched.
	if (tagNavLinks.length && 'IntersectionObserver' in window) {
		const sections = Array.from(document.querySelectorAll('[id]')).filter(
			(el) => document.querySelector(`.tag-nav a[href="#${el.id}"]`)
		);

		if (sections.length) {
			const spyObserver = new IntersectionObserver(
				(entries) => {
					if (Date.now() < suppressSpyUntil) return;

					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;
						const link = document.querySelector(`.tag-nav a[href="#${entry.target.id}"]`);
						if (link) {
							setActiveLink(link);
						}
					});
				},
				{
					root: null,
					// Narrow band roughly mid-viewport (below the sticky bar
					// regardless of breakpoint) — a section "activates" once
					// its heading crosses that line, the standard scroll-spy
					// technique, so this doesn't need to know the bar's exact
					// pixel height the way the click-offset (task 4c) does.
					rootMargin: '-45% 0px -50% 0px',
					threshold: 0,
				}
			);

			sections.forEach((section) => spyObserver.observe(section));
		}
	}
}
